<div class="create-account-pj">
  @if (saving()) {
    <div class="create-account-pj__loading">
      <div class="create-account-pj__loading-card">
        <aprova-loading-bar title="Criando a conta da empresa..." />
      </div>
    </div>
  } @else if (!createdEmail()) {
    <div class="create-account-pj__content">
      <h1 class="create-account-pj__title" data-testid="companyRegistrationTitle">Criação de conta PJ</h1>

      <aprova-stepper
        type="bullets"
        [steps]="steps"
        [currentStep]="currentStep()"
        [showStepLabels]="true"
        [allowDirectNavigation]="false"
      />

      @switch (currentStep()) {
        @case (0) {
          <app-company-form
            [cityConnection]="city?.connection"
            [cityId]="city?.index"
            [lockedIdentity]="true"
            (setStepValidation)="setStepValidation(0, $event)"
          />
        }
        @case (1) {
          <app-address-form
            [hideRecaptcha]="true"
            [isLastStep]="true"
            (setStepValidation)="setStepValidation(1, $event)"
          />
        }
      }

      <div class="create-account-pj__actions">
        <button
          type="button"
          class="create-account-pj__btn create-account-pj__btn--secondary"
          data-testid="companyRegistrationButtonBack"
          (click)="goBack()"
        >
          Voltar
        </button>
        <button
          type="button"
          class="create-account-pj__btn create-account-pj__btn--primary"
          data-testid="companyRegistrationButtonNext"
          [disabled]="!stepValidity()[currentStep()] || stepping()"
          (click)="goToNextStep()"
        >
          @if (stepping()) {
            Carregando...
          } @else {
            {{ currentStep() === steps.length - 1 ? 'Finalizar' : 'Continuar' }}
          }
        </button>
      </div>
    </div>
  } @else {
    <div class="create-account-pj__success" data-testid="companyRegistrationMessageSuccess">
      <div class="create-account-pj__success__icon">
        <aprova-icon name="check-circle-solid" size="lg" color="currentColor" />
      </div>
      <div class="create-account-pj__success__content">
        <p class="create-account-pj__success__title">Conta da empresa criada!</p>
        <p class="create-account-pj__success__subtitle">
          Enviamos um link de confirmação para {{ createdEmail() }}.<br />
          Depois de confirmar, entre com o gov.br para acessar a conta da empresa.
        </p>
        <span data-testid="companyRegistrationButtonLogin">
          <aprova-button
            buttonType="button"
            buttonClass="app-create-account__success__login__btn"
            label="Ir para o login"
            (click)="redirectToLogin()"
          />
        </span>
      </div>
    </div>
  }
</div>
